import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import slotsReduser from './slotsSlice';
import eventReducer from './eventSlice';
import requestsReduser from './requestsSlice';
import attendeeReduser from './attendeeSlice';
import attendeesReduser from './attendeesSlice';
import categoriesReduser from './categoriesSlice';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        slots: slotsReduser,
        event: eventReducer,
        requests: requestsReduser,
        attendee: attendeeReduser,
        attendees: attendeesReduser,
        categories: categoriesReduser,
    }
});


export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
